import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-example',
    templateUrl: './modal-example.component.html',
    styleUrls: ['./modal-example.component.scss']
})
export class ModalExampleComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ModalExampleComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
    }

    public closeModal(): void {
        this.dialogRef.close();
    }

    public confirmModal(): void {
        this.dialogRef.close(true);
    }

}
